import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-left: 2.75rem;
`

Wrapper.displayName = 'Wrapper'

export const CommentSuggestionOptions = styled.div`
  gap: var(--spacer-2);
`

CommentSuggestionOptions.displayName = 'CommentSuggestionOptions'

export const CommentSuggestionOption = styled.button`
  transition: background-color ease 250ms;
  background-color: transparent;
  white-space: nowrap;

  &:hover {
    background-color: var(--gray-200);
  }
`

CommentSuggestionOption.displayName = 'CommentSuggestionOption'
